import _typeof from '@babel/runtime-corejs3/helpers/esm/typeof';
import React__default from 'react';

// Type definition for children

// Extend the type to include displayName

var getDisplayName = function getDisplayName(children) {
  if (Array.isArray(children)) {
    if (children.length > 0 && /*#__PURE__*/React__default.isValidElement(children[0])) {
      var firstChild = children[0];
      var type = firstChild.type;
      if (typeof type === 'function' || _typeof(type) === 'object') {
        var componentType = type;
        return componentType.displayName;
      }
    }
  } else if (/*#__PURE__*/React__default.isValidElement(children)) {
    var _type = children.type;
    if (typeof _type === 'function' || _typeof(_type) === 'object') {
      var _componentType = _type;
      return _componentType.displayName;
    }
  }
  return undefined;
};

export { getDisplayName };
//# sourceMappingURL=getDisplayName.js.map
